"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadPartyUpdate = void 0;
const Party_1 = require("../../classes/Party");
const definables_1 = require("definables");
const loadPartyUpdate = (partyUpdate) => {
    const party = (0, definables_1.definableExists)(Party_1.Party, partyUpdate.partyID)
        ? (0, definables_1.getDefinable)(Party_1.Party, partyUpdate.partyID)
        : new Party_1.Party({ id: partyUpdate.partyID });
    party.playerIDs = partyUpdate.playerIDs;
};
exports.loadPartyUpdate = loadPartyUpdate;
